export const VALIDATION_ERROR_CLASS = 'form__validation-error-message';
export const DIRTY_CLASS = 'form__input--dirty';
export const VALID_CLASS = 'form__input--valid';
export const VALIDATION_ERROR_PARENT_CLASS = 'parent-error';
export const INPUT_INVALID_CLASS = 'form__input--invalid';
export const INPUT_SKIP_VALIDATIONS = 'form__input_skip_validations';
export const DISABLED_SUBMIT_INPUT = 'btn--disabled';
export const CUSTOM_DATE_CLASS = 'custom_format_date';
